module.exports = __webpack_public_path__ + "img/ginestar-escudo.d61e96e3.jpeg";